require('./bootstrap');

$(document).ready(function () {

    let formPhotos = [];

    $('div.application form').one('submit', function (e) {
        e.preventDefault();

        formPhotos.forEach(function (photo) {
            $('<input />').attr('type', 'hidden')
                .attr('name', 'images[]')
                .attr('value', photo.content)
                .appendTo('div.application form');
        });

        $(this).find('input#photos').val(JSON.stringify(formPhotos));

        $(this).submit();
    });

    $('button.add-photos').click(function (e) {
        e.preventDefault();
        $('input#photoUploader').click();
    });

    $('input#photoUploader').change(function () {
        for (let i = 0; i < this.files.length; i++) {
            let file = this.files[i];
            let fileReader = new FileReader();

            fileReader.onload = function (e) {
                if (file.size < 3072000 && formPhotos.length < 12) {
                    let fileId = formPhotos.length + 1;
                    $('div.photos .row').append('<div class="col-lg-2 col-3"><div class="photo" data-file-id="' + fileId + '"><img src="' + e.target.result + '"></div></div>');
                    formPhotos.push({id: fileId, content: e.target.result});
                }
            };
            fileReader.readAsDataURL(this.files[i]);
        }

        $('div.photos .upload-notice').hide();

        $(this).val('');
    });

    $(document).on('click', 'div.photos .photo', function (e) {
        let fileId = $(this).data('file-id');

        formPhotos.forEach(function (photo, i) {
            if (photo.id === fileId) {
                formPhotos.splice(i, 1);
            }
        });

        $(this).closest('div[class^="col-"]').remove();

        if (formPhotos.length === 0) {
            $('div.photos .upload-notice').show();
        }
    });

    $('div.form-group input, div.form-group textarea').change(function () {
        let length = $(this).val().length;

        if (length > 0) {
            $(this).closest('div.form-group').addClass('filled');
        } else {
            $(this).closest('div.form-group').removeClass('filled');
        }
    });

    $('div.faq-category').click(function () {
        $('div.faq-category').removeClass('active');
        $(this).addClass('active');

        $('div.faq-list h3').text($(this).find('h6').text());

        $('div.category').hide();
        $('div.category[data-category="' + $(this).data('category') + '"]').show();
    });
});

$(document).scroll(function () {
    let y = $(this).scrollTop();
    if (y > 150) {
        $('.floating-application-button').fadeIn();
    } else {
        $('.floating-application-button').fadeOut();
    }
});
